import { deleteRequest, put } from '..';

const uploadAssetImage = (assetId: string, image: string) => {
  const endpoint: string = `assets/v2/${assetId}/image`;
  if (image?.length > 0) return put(endpoint, { image });
  return deleteRequest(endpoint);
};

export default uploadAssetImage;
